module.exports = __webpack_public_path__ + "img/ic_filter.7b0905f1.svg";